import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PasswordToggle' })((theme) => ({
  toggleEyeIcon: {
    paddingRight: theme.spacing(1),
  },
}));

export default useStyles;
